import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withXhr, withInterceptorsFromDi } from '@angular/common/http';
import { StdModule, NtsAppRootModule } from '@nts/std';
import { FormsModule } from '@angular/forms';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NtsBootService } from '@nts/std';
import { environment } from '../environments/environment';
import { environment as devEnvironment } from '../environments/environment.dev';
import { EnvironmentConfiguration } from '@nts/std/environments';
import { UNPROXIED_ENVIRONMENT, unproxiedEnvironmentFactory } from '@nts/std/environments';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [BrowserModule,
AppRoutingModule,
BrowserModule,
BrowserAnimationsModule,
CommonModule,
FormsModule,
StdModule,
ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })],
  providers: [provideHttpClient(withXhr(), withInterceptorsFromDi()),

    {
      provide: EnvironmentConfiguration,
      useValue: { ...environment }
    },
    {
      provide: UNPROXIED_ENVIRONMENT,
      useFactory: unproxiedEnvironmentFactory(devEnvironment),
      deps: [EnvironmentConfiguration]
    },
    ...StdModule.getRootProviders(),
  ],
  bootstrap: [AppComponent]
})
export class AppModule extends NtsAppRootModule {
  constructor(
    bootService: NtsBootService
  ) {
    super(bootService);
  }
}
